(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-more-popup"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('buy-more-tabs')) {
    customElements.define('buy-more-tabs', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };

        this.addEventListener('click', (event) => {
          const tab = event.target.closest('[data-buy-more-tab]');
          if (tab && this.contains(tab)) this.selectTab(tab);
        }, options);

        this.addEventListener('keydown', (event) => {
          const tab = event.target.closest('[data-buy-more-tab]');
          if (!tab || !this.contains(tab)) return;
          const tabs = Array.from(this.querySelectorAll('[data-buy-more-tab]'));
          let index = tabs.indexOf(tab);
          if (event.key === 'Home') index = 0;
          else if (event.key === 'End') index = tabs.length - 1;
          else if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            const direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
            const step = event.key === 'ArrowRight' ? direction : -direction;
            index = (index + step + tabs.length) % tabs.length;
          } else return;
          event.preventDefault();
          this.selectTab(tabs[index]);
          tabs[index].focus();
        }, options);

      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      selectTab(selectedTab) {
        const panelId = selectedTab.getAttribute('aria-controls');
        this.querySelectorAll('[data-buy-more-tab]').forEach((tab) => {
          const selected = tab === selectedTab;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
        });
        this.querySelectorAll('[data-buy-more-panel]').forEach((panel) => {
          panel.hidden = panel.id !== panelId;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
